import React from "react";

const About = () => {
  return (
    <section id="about" className="container mx-auto px-4 py-10 space-y-16">
      {/* Who I Am Section */}
      <div className="flex flex-col items-center text-gray-700 dark:text-gray-300">
        <h2 className="text-4xl font-bold mb-4 text-brandcolour">
          Who I Am
        </h2>
        <p className="text-lg text-center md:w-2/3 leading-relaxed">
          My name is{" "}
          <span className="text-brandcolour font-semibold">Ty Ashmore</span>, and
          I'm the founder of{" "}
          <span className="text-brandcolour font-semibold">HaZe IT Solutions</span>.
          With a passion for technology and a commitment to excellence, I've
          been helping businesses achieve their digital goals for the past year.
        </p>
      </div>

      {/* What I Offer Section */}
      <div className="text-center">
        <h2 className="text-4xl font-bold mb-6 text-black dark:text-white">
          What I Offer
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {[
            {
              title: "Website Creation",
              description:
                "Build modern, responsive websites tailored to your business needs using cutting-edge technologies.",
            },
            {
              title: "SEO Optimization",
              description:
                "Improve your website's visibility with effective SEO strategies to grow your online presence.",
            },
            {
              title: "Small-Scale Applications",
              description:
                "Develop lightweight, efficient applications to support your business operations and goals.",
            },
          ].map((item, index) => (
            <div
              key={index}
              className="p-6 bg-gray-100 dark:bg-gray-800 rounded-lg shadow-md hover:shadow-lg transition-shadow"
            >
              <h3 className="text-2xl font-semibold mb-4 text-black dark:text-gray-100">
                {item.title}
              </h3>
              <p className="text-lg leading-relaxed text-gray-700 dark:text-gray-300">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className="text-center">
        <h2 className="text-4xl font-bold mb-6 text-black dark:text-white">
          Why Choose Us
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {[
            {
              title: "Experience",
              description:
                "Over 2 years of experience in web development, SEO, and IT solutions.",
            },
            {
              title: "Commitment to Quality",
              description:
                "We prioritize quality and customer satisfaction in every project.",
            },
            {
              title: "Custom Solutions",
              description:
                "Tailored IT solutions that align with your business needs and goals.",
            },
          ].map((item, index) => (
            <div
              key={index}
              className="p-6 bg-gray-100 dark:bg-gray-800 rounded-lg shadow-md hover:shadow-lg transition-shadow"
            >
              <h3 className="text-2xl font-semibold mb-4 text-black dark:text-gray-100">
                {item.title}
              </h3>
              <p className="text-lg leading-relaxed text-gray-700 dark:text-gray-300">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
